<div class="text-right">
  <mat-icon class="cursor-pointer" (click)="close()">close</mat-icon>
</div>
<input
  type="text"
  class="form-control rounded"
  [formControl]="searchControl"
  placeholder="Type your request here and press enter"
  (keydown.enter)="search()"
  />
@if ({ pexelsRes: pexelsRes$ | async }; as data) {
  <div class="grid-wrapper">
    @for (_ of data.pexelsRes?.photos || []; track _; let count = $count) {
      <div
        class="cursor-pointer"
        (click)="pick(_)"
			[ngClass]="{
				wide: count % 5 === 0,
				tall: _.height > _.width,
				big: count % 10 === 0
			}"
        >
        <img loading="lazy" [src]="_.src.medium" [alt]="_.alt" />
      </div>
    }
  </div>
  @if (data.pexelsRes?.photos.length) {
    <div class="d-flex w-100 justify-content-end">
      <mat-paginator
        [length]="data.pexelsRes.total_results || 0"
        [pageSize]="pageSize"
        [pageIndex]="currentPage - 1"
        (page)="changePage($event)"
      ></mat-paginator>
    </div>
  }
}

@if (loading) {
  <div class="d-flex w-100 justify-content-center">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
}
